import React from 'react';
import Styles from './span-required-styles.scss';
const SpanRequired = () => React.createElement("span", { className: Styles.spanRequired }, "*");
export default SpanRequired;
